/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Group_Type_LabelInputs */

const en_plain_text_import_group_type_label = /** @type {(inputs: Plain_Text_Import_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group Type`)
};

const fr_plain_text_import_group_type_label = /** @type {(inputs: Plain_Text_Import_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de groupe`)
};

const de_plain_text_import_group_type_label = /** @type {(inputs: Plain_Text_Import_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppentyp`)
};

const it_plain_text_import_group_type_label = /** @type {(inputs: Plain_Text_Import_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di gruppo`)
};

const ru_plain_text_import_group_type_label = /** @type {(inputs: Plain_Text_Import_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип группы`)
};

const es_plain_text_import_group_type_label = /** @type {(inputs: Plain_Text_Import_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de grupo`)
};

const zh_cn2_plain_text_import_group_type_label = /** @type {(inputs: Plain_Text_Import_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组类型`)
};

const ja_plain_text_import_group_type_label = /** @type {(inputs: Plain_Text_Import_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループタイプ`)
};

const hi_plain_text_import_group_type_label = /** @type {(inputs: Plain_Text_Import_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूह प्रकार`)
};

const pt_pt2_plain_text_import_group_type_label = /** @type {(inputs: Plain_Text_Import_Group_Type_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de grupo`)
};

/**
* | output |
* | --- |
* | "Group Type" |
*
* @param {Plain_Text_Import_Group_Type_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_group_type_label = /** @type {((inputs?: Plain_Text_Import_Group_Type_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Group_Type_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_group_type_label(inputs)
	if (locale === "de") return de_plain_text_import_group_type_label(inputs)
	if (locale === "it") return it_plain_text_import_group_type_label(inputs)
	if (locale === "ru") return ru_plain_text_import_group_type_label(inputs)
	if (locale === "es") return es_plain_text_import_group_type_label(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_group_type_label(inputs)
	if (locale === "ja") return ja_plain_text_import_group_type_label(inputs)
	if (locale === "hi") return hi_plain_text_import_group_type_label(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_group_type_label(inputs)
	return en_plain_text_import_group_type_label(inputs)
});